<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择仓位"
      width="1100px"
      top="8vh">
    <table-select
        ref="tableSelect"
        :filter="filter"
        :columns="columns"
        module="basic"
        url="warehouseLocations"
        @select="selectWarehouseLocation"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter" @keyup.enter.native="loadData()">
          <el-form-item label="仓库名称" prop="warehouseName">
            <el-input v-model.trim="filter.warehouseName" placeholder="请输入名称" clearable/>
          </el-form-item>
          <el-form-item label="库区名称" prop="warehouseAreaName">
            <el-input v-model.trim="filter.warehouseAreaName" placeholder="请输入名称" clearable/>
          </el-form-item>
          <el-form-item label="仓位名称" prop="warehouseLocationName">
            <el-input v-model.trim="filter.warehouseLocationName" placeholder="请输入名称" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    components: { TableSelect },
    data() {
      return {
        dialogVisible: false,
        filter: {
          warehouseName: "",
          warehouseAreaName: "",
          warehouseLocationName: "",
        },
        columns: [
          {
            title: "仓库名称",
            key: "warehouseName",
          },
          {
            title: "库区名称",
            key: "warehouseAreaName",
          },
          {
            title: "仓位名称",
            key: "warehouseLocationName",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.$refs.tableSelect.loadData();
        });
      },
      loadData(){
        this.$refs.tableSelect.loadData();
      },
      selectWarehouseLocation(row) {
        this.dialogVisible = false;
        this.$emit("select", row);
      },

      resetHandle(filter) {
        this.filter = filter;
        this.$nextTick(() => {
          this.$refs.tableSelect.loadData();
        });
      },
    },
  };
</script>
